import React from "react";
const promoData = [
    {
        icon: "fas fa-cubes",
        title: "Fully Functional",
        description:
            "Phosfluorescently target bleeding sources through viral methods. Progressively expedite empowered solutions.",
    },
    {
        icon: "fas fa-headset",
        title: "24/7 Live Chat",
        description:
            "Enthusiastically productivate interactive interfaces after scaling client-centered catalysts.",
    },
    {
        icon: "fas fa-lock",
        title: "Secure Data",
        description:
            "Synergistically architect virtual content solutions. Communicate cooperative solutions via user-centric portals.",
    },
];

const PromoSection = () => {
    return (
        <section className="promo-section ptb-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-6">
                        <div className="section-heading text-center">
                            <h2>We Provide You World-Class Hosting Features</h2>
                            <p>
                                Uniquely repurpose strategic core competencies with progressive content. Assertively transition ethical imperatives and collaborative solutions.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    {promoData.map((item, index) => (
                        <div key={index} className="col-md-6 col-lg-4">
                            <div className="card single-promo-card single-promo-hover text-center p-2 mt-4">
                                <div className="card-body">
                                    <div className="pb-2">
                                        <span className={`${item.icon} icon-size-lg color-primary`}></span>
                                    </div>
                                    <div className="pt-2 pb-3">
                                        <h5>{item.title}</h5>
                                        <p className="mb-0">{item.description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PromoSection;
